var render = function render(){var _vm=this,_c=_vm._self._c;return _c('multi-select',{attrs:{"value":_vm.value,"label":"name","multiple":false,"options":_vm.countries,"loading":_vm.loading,"searchable":true,"track-by":"id","placeholder":this.$t('SEARCH'),"select-label":this.$t('APPLY')},on:{"search-change":_vm.search,"input":_vm.onSelect}})
}
var staticRenderFns = []

export { render, staticRenderFns }